import { SaveGMBTokenParams } from '../types/gmb.types';
import { saveTokens } from '../../../../../services/socialTokenService';
import { debug } from "../../../../../utils/debugLogger";
import { createOAuthState } from "../../../../../utils/oauthState";
import { exchangeOAuthCode } from "../../../../../services/oauthTokenExchange";
// Constants
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
// Always use env for redirect URI; dev can fallback to localhost
const REDIRECT_URI =
  process.env.REACT_APP_GOOGLE_REDIRECT_URI ||
  process.env.REACT_APP_REDIRECT_URI ||
  (process.env.NODE_ENV === "development" ? "http://localhost:3000/connect/google/callback" : "");

/**
 * Initiates OAuth flow for Google My Business
 */
export const connectToGoogleMyBusiness = () => {
  if (!REDIRECT_URI) {
    debug.error("Redirect URI not set");
    throw new Error("Oops! Something went wrong. Please try again later.");
  }
  debug.log("Connecting to Google My Business...");
  const state = createOAuthState("gmb");
  const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${GOOGLE_CLIENT_ID}&redirect_uri=${encodeURIComponent(
    REDIRECT_URI
  )}&scope=${encodeURIComponent(
    "https://www.googleapis.com/auth/business.manage https://www.googleapis.com/auth/userinfo.email"
  )}&access_type=offline&prompt=consent&state=${encodeURIComponent(state)}`;

  window.location.href = authUrl;
};

/**
 * Exchange authorization code for access and refresh tokens
 */
export const getGMBAccessToken = async (authorizationCode: string) => {
  try {
    // Exchanged on the server: the client secret never reaches the browser.
    const data = await exchangeOAuthCode("google", authorizationCode, REDIRECT_URI);
    const { id_token, access_token, refresh_token, expires_in } = data;
    
    // Calculate expiration time
    const expires_at = Date.now() + (expires_in * 1000);

    // Decode the ID token to get the email
    const payload = JSON.parse(atob(id_token.split(".")[1]));
    const email = payload.email;
    
    return { 
      email, 
      access_token, 
      refresh_token, 
      expires_at,
      scopes: "https://www.googleapis.com/auth/business.manage https://www.googleapis.com/auth/userinfo.email"
    };
  } catch (error) {
    debug.error('Error fetching tokens:', error);
    throw error;
  }
};

/**
 * Save Google My Business tokens to backend
 */
export const saveGMBTokens = async (
  payload: SaveGMBTokenParams,
  idToken: string
) => {
  // Call the shared social token service function
  return await saveTokens(payload, idToken);
};